import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./login.css"; // Assuming you will add your styles in a separate file

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};

    // Validation
    if (!email.trim()) {
      validationErrors.email = "Email is required.";
    }
    if (!password) {
      validationErrors.password = "Password is required.";
    } else if (password.length < 8) {
      validationErrors.password = "Password must be at least 8 characters.";
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await axios.post("https://back.startupconnectz.com/api/admin/login", {
          email,
          password,
        });

        const { token, role } = response.data;

        // Store token in localStorage
        localStorage.setItem("authToken", token);

        // Redirect based on role
        if (role === "admin") {
          navigate("/admin"); // Admin dashboard
        } else {
          navigate("/user-dashboard"); // Default user dashboard
        }
      } catch (error) {
        setErrors({ general: error.response?.data?.message || "Invalid credentials." });
      }
    }
  };

  return (
    <div className="login-container">
      <h2>ADMIN LOGIN</h2>
      {errors.general && <div className="error-message">{errors.general}</div>}
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            aria-label="Email"
          />
          {errors.email && <div className="error-text">{errors.email}</div>}
        </div>
        
        <div className="input-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            aria-label="Password"
          />
          {errors.password && <div className="error-text">{errors.password}</div>}
        </div>

        <button type="submit" className="login-btn">
          Login
        </button>
      </form>
      <a href="#" className="lost-password">
        Lost Password?
      </a>
    </div>
  );
};

export default AdminLogin;
